import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  CardHeader,
  Nav,
  Row,
  Spinner,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import CloudsBedsIntegrationThumb from './CloudsBedsIntegrationThumb';
import { connect } from 'react-redux';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import AddIntegration from './AddIntegration';
import AddVoucherIntregation from './AddVoucherIntegration';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Ingetration,
  API_Ingetration,
  gAPI_Property_List_By_Group,
  gAPI_Stripe_Connection,
  dAPI_Delete_Ingetration,
  postAPI_TrackEvent,
} from '../../../../../constants/APIs';
import { faSalesforce, faOpera } from '@fortawesome/free-brands-svg-icons';
import { faHandshake } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VoucherWebsiteIntregationThumb from './VoucherWebsiteIntregation';
import IntegrationList from './IntegrationList';
import FacebookIntegration from './FacebookIntegration';
import WebIntegrationThumb from './WebIntegrationThumb';
import FacebookIntegrationThumb from './FacebookIntegrationThumb';
import PhoneIntegrationThumb from './PhoneIntegrationThumb';
import PhoneIntegration from './PhoneIntegration';
import GoogleBuisnessIntegration from './GoogleBuisnessIntegration';
import GoogleBusinessIntegrationThumb from './GoogleBusinessIntegrationThumb';
import RevinateIntegration from './RevinateIntegration';
import RevinateIntegrationThumb from './RevinateIntegrationThumb';
import WechatIntegration from './WechatIntegration';
import WechatIntegrationThumb from './WechatIntegrationThumb';
import StripeIntregation from './StripeIntregation';
import OpenAccount from './OpenAccount';
import ShowMessage from './ShowMessage';
import AddEmailIntegration from './Email/AddEmailIntegration';
import EmailIntegrationThumb from './Email/EmailIntegrationThumb';
import StripeIntregationThumb from './StripeIntregrationThumb';
import bot_icon from './../../../../../assets/bot_icon.png';
import RevinateLogo from '../../../../../assets/Revinate-logo.png';
import WechatLogo from '../../../../../assets/wechat_icon.png';
import InstaLogo from '../../../../../assets/insta_logo.png';
import FlexiPass from '../../../../../assets/flexi_pass.jpg';
import MessengerX from '../../../../../assets/MessengerX.png';
import EmailLogo from '../../../../../assets/email.png';
import PhoneLogo from '../../../../../assets/phone.png';
import WhatsApp_Logo from '../../../../../assets/whatsapp_icon.svg';
import RMSLogo from '../../../../../assets/rms.ico';
import SiteMinderLogo from '../../../../../assets/siteminder.svg';
import AmadeusLogo from '../../../../../assets/amadeus_logo.png';
import BookingEngineLogo from '../../../../../assets/be_url_icon.svg';
import ServicePageIcon from '../../../../../assets/servicepage_icon.svg';
import VirtualFront from '../../../../../assets/virtual_front.svg';
import Myma_Logo from '../../../../../assets/myma_logo.png';
import Mews_Logo from '../../../../../assets/mews_logo.jpg';
import Genesys_Cloud_Logo from '../../../../../assets/genesys_cloud_logo.png';
import PhoneSuiteLogo from '../../../../../assets/phone_suite_logo.png';
import RestApiLogo from '../../../../../assets/rest_api_icon.png';
import FB_logo from '../../../../../assets/fb_logo.png';
import Google_Icon from '../../../../../assets/google_icon.png';
import Phone_Logo from '../../../../../assets/phone_logo.png';
import Phone_New_Logo from '../../../../../assets/phone_new_logo.png';
import Oracle_logo from '../../../../../assets/Oracle_logo.png';
import Zendesk_logo from '../../../../../assets/zendesk_logo.png';
import SHR_Logo from '../../../../../assets/SHR_Logo.png';
import WebRTC_logo from '../../../../../assets/webrtc.jpg';
import RMSIntegration from './RMSIntegration';
import SiteminderIntegration from './SiteminderIntegration';
import AmadeusIntegration from './AmadeusIntegration';
import AmadeusIntegrationThumb from './AmadeusIntegrationThumb';
import BookingEngineUrlIntegration from './BookingEngineUrlIntegration';
import BookingEngineUrlIntegrationThumb from './BookingEngineUrlIntegrationThumb';
import AddServiceStandalonePageIntegration from './ServiceStandalone/AddServiceStandalonePageIntegration';
import StandalonePageIntregationThumb from './ServiceStandalone/StandalonePageIntregationThumb';
import AddEmbedPageIntegration from './EmbedPage/AddEmbedPageIntegration';
import EmbedPageIntegrationThumb from './EmbedPage/EmbedPageIntegrationThumb';
import ShowWarningMessage from './ShowWarningMessage';
import SalesforceIntegrationThumb from './SalesforceIntegrationThumb';
import SalesforceIntegration from './SalesforceIntegration';
import AddStandaloneGuestServicePageIntegration from './GuestServiceStandalone/AddStandaloneGuestServicePageIntegration';
import StandaloneGuestServicePageIntegrationThumb from './GuestServiceStandalone/StandaloneGuestServicePageIntegrationThumb';
import WhatsappIntegration from './WhatsApp/WhatsappIntegration';
import CloudBeds_Logo from '../images/cloudBeds_logo.png';
import meetingroom_logo from '../images/meeting-room.png';
import WhatsappIntegrationThumb from './WhatsApp/WhatsappIntegrationThumb';
import OracleOperaIntegration from './OracleOpera/OracleOperaIntegration';
import OracleOperaIntegrationThumb from './OracleOpera/OracleOperaIntegrationThumb';
import AddHelpCenterIntegration from './HelpCenter/AddHelpCenterIntegration';
import HelpCenterIntegrationThumb from './HelpCenter/HelpCenterIntegrationThumb';
import CloudsBedsIntegration from './CloudsBedsIntegration';
import GoogleAnalyticsThumb from './GoogleAnalyticsThumb';
import GoogleAnalyticsIntegration from './GoogleAnalyticsIntegration';
import Analytics_Logo from './../../../../../assets/google_analytics.png';
import AddHelpCenterGroupIntegration from './HelpCenterGroup/AddHelpCenterGroupIntegration';
import HelpCenterGroupIntegrationThumb from './HelpCenterGroup/HelpCenterGroupIntegrationThumb';
import SpaceStandaloneIntegrationList from './SpaceStandalone/SpaceStandaloneIntegrationList';
import SpaceStandalonePageIntregationThumb from './SpaceStandalone/SpaceStandalonePageIntegrationThumb';
import AddSpaceStandAlonePageIntegration from './SpaceStandalone/AddSpaceStandalonePageIntegration';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import PhoneSuiteIntegration from './PhoneSuite/PhoneSuiteIntegration';
import PhoneSuiteIntegrationThumb from './PhoneSuite/PhoneSuiteIntegrationThumb';
import WebRTCIntegration from './WebRTC/WebRTCIntegration';
import WebRTCIntegrationThumb from './WebRTC/WebRTCIntegrationThumb';
import RESTApiIntegration from './RESTApi/RESTApiIntegration';
import RESTApiIntegrationThumb from './RESTApi/RESTApiIntegrationThumb';
import { changeTabs } from '../../../../../redux/actions';
import SHRCRSIntegration from './SHRCRS/SHRCRSIntegration';
import SHRCRSIntegrationThumb from './SHRCRS/SHRCRSIntegrationThumb';
import InstagramIntegrationThumb from './InstagramIntegrationThumb';
import InstagramIntegration from './InstagramIntegration';
import RMSIntegrationThumb from './RMSIntegrationThumb';
import MewsIntegration from './Mews/MewsIntegration';
import MewsIntegrationThumb from './Mews/MewsIntegrationThumb';
import SabreIntegration from './Sabre/SabreIntegration';
import SabreIntegrationThumb from './Sabre/SabreIntegrationThumb';
import Sabre_Logo from '../../../../../assets/sabre_logo.png';
import AmazonIntegration from './Amazon/AmazonIntegration';
import AmazonIntegrationThumb from './Amazon/AmazonIntegrationThumb';
import Amazon_logo from '../../../../../assets/Amazon_logo.png';
function Integrations({
  match,
  propertyId,
  email,
  isVoucherEngine,
  changeTabs,
  domains,
  locale,
  integrationTab,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [integrations, setIntegrations] = useState([]);
  const [fbintegrations, setfbIntegrations] = useState([]);
  const [stripeIntregation, setStripeIntregations] = useState([]);
  const [phoneintegrations, setPhoneIntegrations] = useState([]);
  const [gbintegrations, setGbIntegrations] = useState([]);
  const [revinateintegrations, setRevinateIntegrations] = useState([]);
  const [weChatintegrations, setWeChatIntegrations] = useState([]);
  const [voucherWebsiteIntregation, setVoucherWebsiteIntregation] = useState(
    []
  );
  const [instagramIntegrations, setInstagramIntegrations] = useState([]);
  const [amadeusIntegration, setAmadeusIntegration] = useState([]);
  const [bookingEngineUrlIntegration, setBookingEngineUrlIntegration] =
    useState([]);
  const [standalonePageIntegration, setStandalonePageIntegration] = useState(
    []
  );
  const [webRTCIntegrations, setWebRTCIntegrations] = useState([]);
  const [embedPageIntegration, setEmbedPageIntegration] = useState([]);
  const [phoneSuiteIntegrations, setPhoneSuiteIntegrations] = useState([]);
  const [
    standaloneGuestServicePageIntegration,
    setStandaloneGuestServicePageIntegration,
  ] = useState([]);
  const [whatsAppintegrations, setWhatsAppIntegrations] = useState([]);
  const [oracleOperaIntegration, setOracleOperaIntegration] = useState([]);
  const [helpCenterIntegration, setHelpCenterIntegration] = useState([]);
  const [helpCenterGroupIntegration, setHelpCenterGroupIntegration] = useState(
    []
  );
  const [emailIntegration, setEmailIntegration] = useState([]);
  const [selectedTab, setSelectedTab] = useState(integrationTab || 'channels');
  const [activeTab, setActiveTab] = useState('standard');
  const [allProperties, setAllProperties] = useState([]);
  const [rmsBookingEngineData, setRMSBookingEngineList] = useState([]);
  const [isAdd, setIsAdd] = useState(false);
  const [isAddFB, setIsAddFB] = useState(false);
  const [isAddPhone, setIsAddPhone] = useState(false);
  const [isAddRevinate, setIsAddRevinate] = useState(false);
  const [isAddWechat, setIsAddWechat] = useState(false);
  const [isAddGb, setIsAddGb] = useState(false);
  const [isAddInsta, setIsAddInsta] = useState(false);
  const [isWebRTCIntegration, setIsWebRTCIntegration] = useState(false);
  const [isAddPhoneSuite, setIsPhoneSuite] = useState(false);
  const [isGoogleAnalyticsAvailable, setIsGoogleAnalyticsAvailable] = useState(false);
  const [isAddEmail, setIsAddEmail] = useState(false);
  const [messageVisible, setmessageVisible] = useState(
    localStorage.getItem('ShowMessage')
      ? localStorage.getItem('ShowMessage')
      : false
  );
  const [cloudBedsVisible, setCloudsBedsVisible] = useState(
    localStorage.getItem('ShowCloudbedsMessage')
      ? localStorage.getItem('ShowCloudbedsMessage')
      : false
  );

  const [instagramVisible, setInstagramVisible] = useState(
    localStorage.getItem('ShowInstagramMessage')
      ? localStorage.getItem('ShowInstagramMessage')
      : false
  );

  const [confirmMessage, setConfirmMeesage] = useState(
    localStorage.getItem('ShowConfirm')
      ? localStorage.getItem('ShowConfirm')
      : false
  );
  const [paymentmodelvisible, setpaymentmodelvisible] = useState(false);
  const [createaccountModel, setcreateaccountModel] = useState(false);
  const [isConnected, setisConnected] = useState(false);
  const [stripeIntegrationId, setStripeIntegrationId] = useState('');
  const [stripepropertyId, setStripeProprtyId] = useState('');
  const [isAddVouchers, setIsAddVouchers] = useState(false);
  const [isAddRms, setIsAddRms] = useState(false);
  const [isAddSiteminder, setIsSiteminderb] = useState(false);
  const [isAddAmadeus, setIsAmadeus] = useState(false);
  const [isAddBookingEngine, setIsAddBookingEngine] = useState(false);
  const [isAddStandalonePage, setIsAddStandalonePage] = useState(false);
  const [isAddEmbedPage, setIsAddEmbedPage] = useState(false);
  const [isAddStandaloneGuestServicePage, setIsAddStandaloneGuestServicePage] =
    useState(false);
  const [isSalesforce, setIsSalesforce] = useState(false);
  const [isAddWhatsApp, setIsAddWhatsApp] = useState(false);
  const [isAddOracleOpera, setIsAddOracleOpera] = useState(false);
  const [isAddHelpCenter, setIsAddHelpCenter] = useState(false);
  const [isAddHelpCenterGroup, setIsAddHelpCenterGroup] = useState(false);
  const [salesforceIntegration, setSalesforceIntegration] = useState([]);
  const [warningMsgVisible, setWarningMsgVisible] = useState(false);
  const [cloudBeds, setCloudsBeds] = useState([]);
  const [isCloudBeds, setIsCloudsBeds] = useState(false);
  const [googleAnalytics, setGoogleAnalytics] = useState([]);
  const [isGoogleAnalytics, setIsGoogleAnalytics] = useState(false);
  const [spaceStandAloneList, setSpaceStandAloneList] = useState([]);
  const [isSpaceStandalonePage, setIsSpaceStandAlonePage] = useState(false);

  const [sabreIntegrationList, setSabreIntegrationList] = useState([]);
  const [isSabreIntegrationPage, setIsSabreIntegrationPage] = useState(false);

  const [restApiIntegrationList, setRESTApiIntegrationList] = useState([]);
  const [isRESTApiIntegrationPage, setIsRESTApiIntegrationPage] =
    useState(false);
  const [isAddMews, setIsAddMews] = useState(false);
  const [mewsIntegrationList, setMewsIntegrationList] = useState([]);
  const [isAddSHR, setIsAddSHR] = useState(false);
  const [shrCRSIntegrationList, setSHRCRSIntegrationList] = useState();
  const [isAddAmazon, setIsAddAmazon] = useState(false);
  const [amazonIntegration, setAmazonIntegration] = useState([]);

  const handleProerptyId = (id) => {
    setStripeProprtyId(id);
  };
  useEffect(() => {
    setTimeout(() => {
      LoadIntegrations();
    }, 1000);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
      // setIsLoading(false);
    });
    if (email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Integrations',
          email: email,
        },
      }).then(
        (res) => { },
        (error) => { }
      );
    }
  }, [propertyId]);
  const checkConnection = () => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/check`,
      data,
    })
      .then((m) => {
        if (m.data.stripeCustomerId == '') {
        }
        setStripeIntegrationId(m.data.stripeCustomerId);
      })
      .catch((err) => { });
  };
  const RefreshConnection = (status, id) => {
    let data = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
      Creator: 'Admin',
      StripeCustomerId: status === 'Archieve' ? '' : stripeIntegrationId,
      StripeStatus: status,
    };
    AxiosAPI({
      method: 'post',
      url: `${gAPI_Stripe_Connection}/save`,
      data: data,
    })
      .then((res) => {
        if (status === 'Archieve') {
          AxiosAPI({
            method: 'delete',
            url: `${gAPI_Stripe_Connection}/remove?id=${id}`,
            data: data,
          })
            .then((res) => { })
            .catch((err) => { });
        }
      })
      .catch((err) => { });
  };
  const handlePayment = () => {
    var restUrl = window.location.href.substring(
      0,
      window.location.href.lastIndexOf('/') + 1
    );
  };

  useEffect(() => {
    checkConnection();
  }, []);
  const LoadIntegrations = () => {
    setIsLoading(true);
    let body = {
      channels: [
        'WebsiteDirectLine',
        'RMSBookingEngine',
        'FacebookDirectLine',
        'Phone',
        'GoogleBusinessMessage',
        'Revinate',
        'RESTAPI',
        'WeChat',
        'SHRCRS',
        'Amadues',
        'BookingEngineUrl',
        'ServiceStandAlonePage',
        'EmbedService',
        'Salesforce',
        'GuestServiceStandAlonePage',
        'WhatsApp',
        'OracleOpera',
        'HelpCenter',
        'Sabre',
        'InstagramDirectLine',
        'SHRCRS',
        'CloudBeds',
        'Mews',
        'GoogleAnalytics',
        'HelpCenterGroup',
        'SpaceStandalone',
        'PhoneSuite',
        'WebRTC',
        'EmailDirectLine',
        'Amazon'
      ],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body,
    })
      .then((res) => {
        // console.log(res.data);
        const instagramIntegrationData = res.data.filter(
          (k) => k.channel === 'InstagramDirectLine'
        );

        const shrCRSIntegration = res.data.filter(
          (k) => k.channel === 'SHRCRS'
        );
        const webIntegrationData = res.data.filter(
          (k) => k.channel === 'WebsiteDirectLine'
        );
        const fbIntegrationData = res.data.filter(
          (k) => k.channel === 'FacebookDirectLine'
        );
        const phoneIntegrationData = res.data.filter(
          (k) => k.channel === 'Phone'
        );
        const gbIntegrationData = res.data.filter(
          (k) => k.channel === 'GoogleBusinessMessage'
        );
        const revinateIntegrationData = res.data.filter(
          (k) => k.channel === 'Revinate'
        );
        const wechatIntegrationData = res.data.filter(
          (k) => k.channel === 'WeChat'
        );
        const amadeusIntegration = res.data.filter(
          (k) => k.channel === 'Amadues'
        );
        const bookingEngineUrlIntegrationData = res.data.filter(
          (k) => k.channel === 'BookingEngineUrl'
        );
        const standalonePageIntegration = res.data.filter(
          (k) => k.channel === 'ServiceStandAlonePage'
        );
        const embedPageIntegration = res.data.filter(
          (k) => k.channel === 'EmbedService'
        );
        const salesforceIntegrationData = res.data.filter(
          (k) => k.channel === 'Salesforce'
        );
        const standaloneGuestServicePageData = res.data.filter(
          (k) => k.channel === 'GuestServiceStandAlonePage'
        );
        const whatsAppIntegrationData = res.data.filter(
          (k) => k.channel === 'WhatsApp'
        );
        const oracleOperaIntegrationData = res.data.filter(
          (k) => k.channel === 'OracleOpera'
        );
        const helpCenterIntegrationData = res.data.filter(
          (k) => k.channel === 'HelpCenter'
        );
        const cloudsBedsIntegration = res.data.filter(
          (k) => k.channel === 'CloudBeds'
        );
        const googleAnalyticsInegration = res.data.filter(
          (k) => k.channel === 'GoogleAnalytics'
        );
        const helpCenterGroupIntegrationData = res.data.filter(
          (k) => k.channel === 'HelpCenterGroup'
        );
        const spaceStandAloneIntegrationData = res.data.filter(
          (k) => k.channel === 'SpaceStandalone'
        );
        const phoneSuiteIntegrationData = res.data.filter(
          (k) => k.channel === 'PhoneSuite'
        );

        const webRTCIntegrationData = res.data.filter(
          (k) => k.channel === 'WebRTC'
        );

        const restAPIIntegrationData = res.data.filter(
          (k) => k.channel === 'RESTAPI'
        );

        const rmsBookingData = res.data.filter(
          (k) => k.channel === 'RMSBookingEngine'
        );

        const mewsIntegrationData = res.data.filter(
          (k) => k.channel === 'Mews'
        );

        const sabreIntegrationData = res.data.filter(
          (k) => k.channel === 'Sabre'
        );

        const emailIntegrationData = res.data.filter(
          (k) => k.channel === 'EmailDirectLine'
        );
        const amazonIntegrationData = res.data.filter(
          (k) => k.channel === 'Amazon'
        )
        setEmailIntegration(emailIntegrationData);
        setSabreIntegrationList(sabreIntegrationData);
        setMewsIntegrationList(mewsIntegrationData);
        setRMSBookingEngineList(rmsBookingData);
        setRESTApiIntegrationList(restAPIIntegrationData);
        setSHRCRSIntegrationList(shrCRSIntegration);
        setWebRTCIntegrations(webRTCIntegrationData);
        setInstagramIntegrations(instagramIntegrationData);
        setPhoneSuiteIntegrations(phoneSuiteIntegrationData);
        // console.log(spaceStandAloneIntegrationData);
        setSpaceStandAloneList(spaceStandAloneIntegrationData);
        setGoogleAnalytics(googleAnalyticsInegration);
        setCloudsBeds(cloudsBedsIntegration);
        // console.log(salesforceIntegrationData);
        setSalesforceIntegration(salesforceIntegrationData);
        setIntegrations(webIntegrationData);
        setfbIntegrations(fbIntegrationData);
        setPhoneIntegrations(phoneIntegrationData);
        setGbIntegrations(gbIntegrationData);
        setRevinateIntegrations(revinateIntegrationData);
        setWeChatIntegrations(wechatIntegrationData);
        setStripeIntregations([]);
        setVoucherWebsiteIntregation([]);
        setAmadeusIntegration(amadeusIntegration);
        setBookingEngineUrlIntegration(bookingEngineUrlIntegrationData);
        setStandalonePageIntegration(standalonePageIntegration);
        setEmbedPageIntegration(embedPageIntegration);
        setStandaloneGuestServicePageIntegration(
          standaloneGuestServicePageData
        );
        setWhatsAppIntegrations(whatsAppIntegrationData);
        setOracleOperaIntegration(oracleOperaIntegrationData);
        setHelpCenterIntegration(helpCenterIntegrationData);
        setHelpCenterGroupIntegration(helpCenterGroupIntegrationData);
        setAmazonIntegration(amazonIntegrationData);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTabs = (tabs) => {
    changeTabs(tabs);
    setSelectedTab(tabs);
  };
  const handleDelete = (id) => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${id}/?group_id=${getGroupID()}`,
    }).then((res) => {
      LoadIntegrations();
    });
  };
  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };
  const toggleWarning = () => {
    setWarningMsgVisible(!warningMsgVisible);
  };
  //console.log(getGroupID());
  return (
    <Fragment>
      {/* <CardHeader className="pl-0 pr-0">
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem className="w-50 text-center">
            <NavLink
              className={classnames({
                active: activeTab === "standard",
                "nav-link": true
              })}
              onClick={() => {
                toggleAppMenu("standard");
              }}
              to="#"
            >
              Website Integrations
            </NavLink>
          </NavItem>
          <NavItem className="w-50 text-center">
            <NavLink
              className={classnames({
                active: activeTab === "embed",
                "nav-link": true
              })}
              onClick={() => {
                toggleAppMenu("embed");
              }}
              to="#"
            >
              Facebook Integrations
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent
        activeTab={activeTab}
        className=""
      >
        <TabPane tabId="standard" className="chat-app-tab-pane"> */}
      {/* <Row className="mt-2">
            <Colxx xxs="12">
              <Button
                color="primary"
                outline
                style={{
                  width: '100%',
                  borderRadius: '6px',
                }}
                className="mb-4"
                onClick={() => setIsAdd(!isAdd)}
              >
                <b>+ Add New Integration</b>
              </Button>
            </Colxx>
          </Row> */}
      <CardHeader className="mb-2">
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem
            className=" text-center"
            style={{ width: 'auto', background: '' }}
          >
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'channels',
                'nav-link': true,
              })}
              onClick={() => {
                handleTabs('channels');
              }}
              to="#"
            >
              <span
              // style={{
              //   color: `${selectedTab === 'channels' ? 'var(--theme-color-1)' : 'black'}`,
              // }}
              >
                Channels
              </span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === 'applications',
                'nav-link': true,
              })}
              onClick={() => {
                handleTabs('applications');
              }}
              to="#"
            >
              <span
              // style={{
              //   color: `${selectedTab === 'applications' ? 'var(--theme-color-1)' : 'black'
              //     } `,
              // }}
              >
                Applications
              </span>
            </NavLink>
          </NavItem>
          {/* <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: selectedTab === "agentAssist",
                "nav-link": true
              })}
              onClick={() => {
                handleTabs("agentAssist");
              }}
              to="#"
            >
              <span style={{ color: `${selectedTab === "agentAssist" ? 'var(--theme-color-1)' : 'black'} ` }}>Agent Assist</span>
            </NavLink>
          </NavItem> */}
        </Nav>
      </CardHeader>

      <TabContent activeTab={selectedTab} className="">
        <TabPane
          tabId="channels"
          className="chat-app-tab-pane"
          style={{ background: 'none' }}
        >
          {isAdd ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddIntegration
                      visible={isAdd}
                      toggle={() => {
                        setIsAdd(!isAdd);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddVouchers ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddVoucherIntregation
                      visible={isAddVouchers}
                      LoadIntegrations={LoadIntegrations}
                      toggle={() => {
                        setIsAddVouchers(!isAddVouchers);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddFB ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <FacebookIntegration
                      visible={isAddFB}
                      propertyId={propertyId}
                      toggle={() => {
                        setIsAddFB(!isAddFB);
                      }}
                      LoadIntegrations={LoadIntegrations}
                      allProperties={allProperties}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}

          {isSpaceStandalonePage ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddSpaceStandAlonePageIntegration
                      visible={isSpaceStandalonePage}
                      propertyId={propertyId}
                      toggle={() => {
                        setIsSpaceStandAlonePage(!isSpaceStandalonePage);
                      }}
                      LoadIntegrations={LoadIntegrations}
                      allProperties={allProperties}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddPhone ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <PhoneIntegration
                      visible={isAddPhone}
                      toggle={() => {
                        setIsAddPhone(!isAddPhone);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddInsta ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <InstagramIntegration
                      LoadIntegrations={LoadIntegrations}
                      visible={isAddInsta}
                      toggle={() => {
                        setIsAddInsta(!isAddInsta);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddGb ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <GoogleBuisnessIntegration
                      visible={isAddGb}
                      toggle={() => {
                        setIsAddGb(!isAddGb);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddRms ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <RMSIntegration
                      visible={isAddRms}
                      toggle={() => {
                        setIsAddRms(!isAddRms);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddSiteminder ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <SiteminderIntegration
                      visible={isAddSiteminder}
                      toggle={() => {
                        setIsSiteminderb(!isAddSiteminder);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddRevinate ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <RevinateIntegration
                      visible={isAddRevinate}
                      toggle={() => {
                        setIsAddRevinate(!isAddRevinate);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isSalesforce ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <SalesforceIntegration
                      visible={isSalesforce}
                      toggle={() => {
                        setIsSalesforce(!isSalesforce);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isWebRTCIntegration ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <WebRTCIntegration
                      visible={isWebRTCIntegration}
                      toggle={() => {
                        setIsWebRTCIntegration(!isWebRTCIntegration);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddWechat ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <WechatIntegration
                      visible={isAddWechat}
                      toggle={() => {
                        setIsAddWechat(!isAddWechat);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddAmadeus ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AmadeusIntegration
                      visible={isAddAmadeus}
                      toggle={() => {
                        setIsAmadeus(!isAddAmadeus);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddSHR ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <SHRCRSIntegration
                      visible={isAddSHR}
                      LoadIntegrations={LoadIntegrations}
                      toggle={() => {
                        setIsAddSHR(!isAddSHR);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddPhoneSuite ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <PhoneSuiteIntegration
                      visible={isAddPhoneSuite}
                      LoadIntegrations={LoadIntegrations}
                      toggle={() => {
                        setIsPhoneSuite(!isAddPhoneSuite);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddBookingEngine ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <BookingEngineUrlIntegration
                      visible={isAddBookingEngine}
                      toggle={() => {
                        setIsAddBookingEngine(!isAddBookingEngine);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddStandalonePage ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddServiceStandalonePageIntegration
                      visible={isAddStandalonePage}
                      LoadIntegrations={LoadIntegrations}
                      toggle={() => {
                        setIsAddStandalonePage(!isAddStandalonePage);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddEmbedPage ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddEmbedPageIntegration
                      visible={isAddEmbedPage}
                      LoadIntegrations={LoadIntegrations}
                      toggle={() => {
                        setIsAddEmbedPage(!isAddEmbedPage);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddStandaloneGuestServicePage ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddStandaloneGuestServicePageIntegration
                      visible={isAddStandaloneGuestServicePage}
                      LoadIntegrations={LoadIntegrations}
                      toggle={() => {
                        setIsAddStandaloneGuestServicePage(
                          !isAddStandaloneGuestServicePage
                        );
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddWhatsApp ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <WhatsappIntegration
                      visible={isAddWhatsApp}
                      toggle={() => {
                        setIsAddWhatsApp(!isAddWhatsApp);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddOracleOpera ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <OracleOperaIntegration
                      visible={isAddOracleOpera}
                      toggle={() => {
                        setIsAddOracleOpera(!isAddOracleOpera);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddHelpCenter ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddHelpCenterIntegration
                      visible={isAddHelpCenter}
                      toggle={() => {
                        setIsAddHelpCenter(!isAddHelpCenter);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddHelpCenterGroup ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddHelpCenterGroupIntegration
                      visible={isAddHelpCenterGroup}
                      toggle={() => {
                        setIsAddHelpCenterGroup(!isAddHelpCenterGroup);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isGoogleAnalytics ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <GoogleAnalyticsIntegration
                      visible={isGoogleAnalytics}
                      toggle={() => {
                        setIsGoogleAnalytics(!isGoogleAnalytics);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddEmail ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AddEmailIntegration
                      visible={isAddEmail}
                      toggle={() => {
                        setIsAddEmail(!isAddEmail);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          {isAddAmazon ? (
            <Row>
              <Colxx xxs="12">
                <Row>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12">
                    <AmazonIntegration
                      visible={isAddAmazon}
                      toggle={() => {
                        setIsAddAmazon(!isAddAmazon);
                      }}
                    />
                  </Colxx>
                  <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : null}
          <Row className="m-2 my-3">
            <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: '1.5rem' }}>Available Channels</h1>
              <Separator></Separator>
            </Colxx>

            <Fragment>
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={MessengerX} style={{ maxWidth: '40px' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddHelpCenter(!isAddHelpCenter)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Web Widget for Property Website</h2>
                            <span>
                              Give proactive help, and personal assistance
                              through forms, workflows, and AI chatbot.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={MessengerX} style={{ maxWidth: '40px' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() =>
                            setIsAddHelpCenterGroup(!isAddHelpCenterGroup)
                          }
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Web Widget for Group Website</h2>
                            <span>
                              Give proactive help, and personal assistance
                              through forms, workflows, and AI chatbot.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={bot_icon} style={{ width: '40px' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAdd(!isAdd)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>AI Chatbot for Web Widget</h2>
                            <span>
                              Respond to guest questions with Myma.ai’s
                              breakthrough ChatGPT harnessed AI chatbot.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img
                            src={Google_Icon}
                            style={{ width: '3rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddGb(!isAddGb)}
                        >
                          Feature discontinued by Google
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Google Business Messages</h2>
                            <span>
                              Enable Chat button in Google Maps and automate
                              responses. Manage and reply to conversations from
                              a unified inbox.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={FB_logo} style={{ width: '3rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddFB(!isAddFB)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Facebook Messenger</h2>
                            <span>
                              Automate responses to Facebook messages. Manage
                              and reply to conversations from a unified inbox.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img
                            src={WhatsApp_Logo}
                            style={{ width: '3rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddWhatsApp(!isAddWhatsApp)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>WhatsApp</h2>
                            <span>
                              Automate responses to WhatsApp messages. Manage
                              and reply to conversations from a unified inbox.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card className="d-flex flex-row" style={{ height: '215px' }}>
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={InstaLogo} style={{ width: '3rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddInsta(!isAddInsta)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Instagram</h2>
                            <span>
                              Automate responses to Instagram private messages.
                              Manage and reply to conversations from a unified
                              inbox.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {/* <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card
            className="d-flex flex-row integrationcard"
            style={{ height: '215px' }}
            onClick={() => setpaymentmodelvisible(!paymentmodelvisible)}
          >
            <div className="position-relative">
              <h3 className="integrationChannel stripe-logo">
                {' '}
                <FontAwesomeIcon icon={faStripe}></FontAwesomeIcon>{' '}
              </h3>
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-5 mt-5">
                  <div className="text-center">
                    <div className="mb-1">
                      <h1 className="iconsminds-add" />
                    </div>
                    <h2>Connect to Stripe</h2>
                  </div>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx> */}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={WechatLogo} style={{ width: '3rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddWechat(!isAddWechat)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>WeChat</h2>
                            <span>
                              Automate responses to WeChat messages. Manage and
                              reply to conversations from a unified inbox.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img
                            src={Phone_Logo}
                            style={{ width: '2.5rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddPhone(!isAddPhone)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Telephony with Amazon Connect </h2>
                            <span>
                              Automate phone communication using Voice AI
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img
                            src={PhoneLogo}
                            style={{ width: '3rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsPhoneSuite(!isAddPhoneSuite)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Telephony with Voice AI </h2>
                            <span>
                              Automate phone communication using Voice AI
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img
                            src={EmailLogo}
                            style={{ width: '3rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddEmail(!isAddEmail)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Email</h2>
                            <span>
                              Handle emails from Unified Inbox, with AI suggestions and responses.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
            </Fragment>

            <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: '1.5rem' }}>Your Connected Channels</h1>
              <Separator></Separator>
            </Colxx>

            {isLoading ? (
              <div className="text-center">
                <Spinner color="primary" className="mb-1" />
              </div>
            ) : (
              <Fragment>
                {integrations && (!isVoucherEngine || domains.length > 1)
                  ? integrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <WebIntegrationThumb
                          integration={integration}
                          // propertyId={propertyId}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {weChatintegrations && (!isVoucherEngine || domains.length > 1)
                  ? weChatintegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <WechatIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {fbintegrations && (!isVoucherEngine || domains.length > 1)
                  ? fbintegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <FacebookIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {phoneintegrations && (!isVoucherEngine || domains.length > 1)
                  ? phoneintegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <PhoneIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {gbintegrations && (!isVoucherEngine || domains.length > 1)
                  ? gbintegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <GoogleBusinessIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {whatsAppintegrations &&
                  (!isVoucherEngine || domains.length > 1)
                  ? whatsAppintegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <WhatsappIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {helpCenterIntegration &&
                  (!isVoucherEngine || domains.length > 1)
                  ? helpCenterIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <HelpCenterIntegrationThumb
                          locale={locale}
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {helpCenterGroupIntegration &&
                  (!isVoucherEngine || domains.length > 1)
                  ? helpCenterGroupIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <HelpCenterGroupIntegrationThumb
                          locale={locale}
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {phoneSuiteIntegrations
                  ? phoneSuiteIntegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <PhoneSuiteIntegrationThumb
                          integration={integration}
                          propertyId={propertyId}
                          refreshConnection={RefreshConnection}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {instagramIntegrations
                  ? instagramIntegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <InstagramIntegrationThumb
                          integration={integration}
                          propertyId={propertyId}
                          refreshConnection={RefreshConnection}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {emailIntegration ?
                  emailIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <EmailIntegrationThumb
                          integration={integration}
                          propertyId={propertyId}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        ></EmailIntegrationThumb>
                      </Fragment>)
                  }) : null}
                {/* {embedPageIntegration && (!isVoucherEngine || domains.length > 1)
              ? embedPageIntegration.map((integration, index) => {
                return (
                  <Fragment key={index}>
                    <EmbedPageIntegrationThumb
                      integration={integration}
                      allProperties={allProperties}
                      LoadIntegrations={LoadIntegrations}
                    />
                  </Fragment>
                );
              })
              : null} */}
              </Fragment>
            )}
          </Row>
        </TabPane>
        <TabPane
          tabId="applications"
          className="chat-app-tab-pane"
          style={{ background: 'none' }}
        >
          <Row className="m-2 my-3">
            <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: '1.5rem' }}>Available Apps</h1>
              <Separator></Separator>
            </Colxx>
            <Fragment>
              {isRESTApiIntegrationPage ? (
                <Row>
                  <Colxx xxs="12">
                    <Row>
                      <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                      <Colxx md="4" sm="4" lg="4" xxs="12">
                        <RESTApiIntegration
                          LoadIntegrations={LoadIntegrations}
                          visible={isRESTApiIntegrationPage}
                          toggle={() => {
                            setIsRESTApiIntegrationPage(
                              !isRESTApiIntegrationPage
                            );
                          }}
                        />
                      </Colxx>
                      <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    </Row>
                  </Colxx>
                </Row>
              ) : null}
              {isSabreIntegrationPage ? (
                <Row>
                  <Colxx xxs="12">
                    <Row>
                      <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                      <Colxx md="4" sm="4" lg="4" xxs="12">
                        <SabreIntegration
                          visible={isSabreIntegrationPage}
                          propertyId={propertyId}
                          toggle={() => {
                            setIsSabreIntegrationPage(!isSabreIntegrationPage);
                          }}
                          LoadIntegrations={LoadIntegrations}
                          allProperties={allProperties}
                        />
                      </Colxx>
                      <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    </Row>
                  </Colxx>
                </Row>
              ) : null}
              {isAddMews ? (
                <Row>
                  <Colxx xxs="12">
                    <Row>
                      <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                      <Colxx md="4" sm="4" lg="4" xxs="12">
                        <MewsIntegration
                          LoadIntegrations={LoadIntegrations}
                          visible={isAddMews}
                          toggle={() => {
                            setIsAddMews(!isAddMews);
                          }}
                        />
                      </Colxx>
                      <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                    </Row>
                  </Colxx>
                </Row>
              ) : null}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={Myma_Logo} style={{ width: '7rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() =>
                            setIsAddStandalonePage(!isAddStandalonePage)
                          }
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Digital Compendium</h2>
                            <span>
                              Provide instant information to your in-house
                              guests in tap of a button, or scan of a QR code.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={Myma_Logo} style={{ width: '7rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() =>
                            setIsSpaceStandAlonePage(!isSpaceStandalonePage)
                          }
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Space Booking Engine (Beta)</h2>
                            <span>
                              Showcase spaces like meeting rooms with inventory,
                              availability, and rates. Streamline booking with
                              only three clicks.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img src={Myma_Logo} style={{ width: '7rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => {
                            bookingEngineUrlIntegration &&
                              bookingEngineUrlIntegration.length === 0
                              ? (window.location.href =
                                '/app/pages/booking-engine-url')
                              : toggleWarning();
                          }}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Booking Engine</h2>
                            <span>
                              Seamlessly send leads from{' '}
                              <a href="https://www.myma.ai/" rel="noopener noreferrer" target="_blank">
                                Myma.ai
                              </a>{' '}
                              Messenger or Chatbot to the property booking
                              engine.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-2">
                          <img
                            src={Analytics_Logo}
                            style={{ width: '3rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => {
                            if (googleAnalytics.length > 0)
                              setIsGoogleAnalyticsAvailable(
                                !isGoogleAnalyticsAvailable
                              );
                            else setIsGoogleAnalytics(!isGoogleAnalytics);
                          }}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Google Analytics</h2>
                            <span>
                              Measure the impact of your Web Widget and AI
                              Chatbot on website conversions.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img
                            src={AmadeusLogo}
                            style={{ width: '5.8rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAmadeus(!isAddAmadeus)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Amadeus</h2>
                            <span>
                              Show availability and rates within a conversation,
                              and track conversion in Amadeus.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-3">
                          <img
                            src={Oracle_logo}
                            style={{ width: '3rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddOracleOpera(!isAddOracleOpera)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '1.5rem' }}
                        >
                          <div className="text-left">
                            <h2>Oracle Opera Cloud</h2>
                            <span>
                              Provide 24/7 pre-checkin engagement. Message your
                              guests before their arrival, with information,
                              guidance, and personalised upsell options.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img src={RMSLogo} style={{ width: '2rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddRms(!isAddRms)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>RMS Booking Engine</h2>
                            <span>
                              Show the Myma.ai Chatbot inside the RMS Booking
                              Engine.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img
                            src={SiteMinderLogo}
                            style={{ width: '1.5rem' }}
                          ></img>
                        </div>
                        <a
                          href="https://help.myma.ai/en/articles/8204057-siteminder-booking-engine-integration"
                          target="_blank"
                          rel="noopener noreferrer"
                        ><Button
                          size="xs"
                          color="primary"
                          outline
                        // onClick={() => setIsSiteminderb(!isAddSiteminder)}
                        >
                            Connect
                          </Button>
                        </a>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Connect to SiteMinder</h2>
                            <span>
                              Make{' '}
                              <a href="https://www.myma.ai/" rel="noopener noreferrer" target="_blank">
                                Myma.ai
                              </a>{' '}
                              MessengerX & Chatbot available within SiteMinder's
                              Booking Engine Pages
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img
                            src={RevinateLogo}
                            style={{ width: '5.9rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddRevinate(!isAddRevinate)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Revinate</h2>
                            <span>
                              Sync contact information with Revinate in
                              realtime.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel ml-2">
                          <FontAwesomeIcon
                            icon={faSalesforce}
                            style={{ fontSize: '3.5rem' }}
                          ></FontAwesomeIcon>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() =>
                            setIsWebRTCIntegration(!isWebRTCIntegration)
                          }
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Salesforce</h2>
                            <span>
                              Sync contact information with Salesforce in
                              realtime.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {/* {isCloudBeds && domains.length == 1 ? (
                  ''
                ) : (
                  <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                    <Card
                      className="d-flex flex-row integrationcard"
                      style={{ height: '215px' }}
                    >
                      <CardBody className="mt-0">
                        <div className='connect-title'>
                          <div className="integrationChannel mt-4 ml-2">
                            <img
                              src={CloudBeds_Logo}
                              alt="Logo"
                              style={{ width: "8rem" }}
                            />
                          </div>
                          <Button
                            size="xs"
                            color="primary"
                            outline
                            onClick={() => setIsCloudsBeds(!isCloudBeds)}
                          >Connect</Button>
                        </div>
                        <Row>
                          <Colxx xxs="12" className="mb-5" style={{ marginTop: "2rem" }}>
                            <div className="text-left">
                              <h2>Cloudbeds</h2>
                            </div>
                          </Colxx>
                        </Row>
                      </CardBody>
                    </Card>
                  </Colxx>
                )} */}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4">
                          <img src={Zendesk_logo} style={{ width: '3rem' }} />
                        </div>
                        <div
                          className="btn-xs"
                          style={{
                            color: 'var(--theme-color-1)',
                            borderRadius: '50px',
                            border: '1px solid var(--theme-color-1)',
                          }}
                        >
                          Enable in Chatbot
                        </div>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Zendesk</h2>
                            <span>
                              Seamless handoff to Zendesk agents when a human
                              touch is necessary, flagging agents when to step
                              in.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-3">
                          <img src={WebRTC_logo} style={{ width: '8rem' }} />
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsWebRTCIntegration(!isSalesforce)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>WebRTC for web calling</h2>
                            <span>
                              Enable voice calling for your agents and customers
                              inside the Myma.ai applications
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-3">
                          <img src={RestApiLogo} style={{ width: '3rem' }} />
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() =>
                            setIsRESTApiIntegrationPage(
                              !isRESTApiIntegrationPage
                            )
                          }
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>External Rest API’s</h2>
                            <span>
                              Integrate to any external API to post or get the
                              data
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img src={SHR_Logo} style={{ width: '5.8rem' }}></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddSHR(!isAddSHR)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>SHR CRS</h2>
                            <span>
                              Show availability and rates within a conversation,
                              and track conversion in SHR.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img
                            src={Genesys_Cloud_Logo}
                            style={{ width: '8.8rem' }}
                          ></img>
                        </div>
                        <Button size="xs" color="primary" outline>
                          Enable in Chatbot
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Genesys PureCloud</h2>
                            <span>
                              Seamless handoff to Genesys PureCloud agents when
                              a human touch is necessary, flagging agents when
                              to step in.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img
                            src={Mews_Logo}
                            style={{ width: '5.8rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddMews(!isAddMews)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Mews Operations</h2>
                            <span>
                              Seamless handoff to customer messaging system of
                              Mews when a human touch is necessary, alerting
                              staff when to step in.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img
                            src={FlexiPass}
                            style={{ width: '6.8rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() =>
                            window.open('https://www.myma.ai/contact', '_blank')
                          }
                        >
                          Contact Us
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Saltos Online Locks</h2>
                            <span>
                              Myma.ai in partnership with FLEXIPASS deliver
                              WebKeys experience to open door from Digital
                              Compendium.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img
                            src={Sabre_Logo}
                            style={{ width: '5.8rem' }}
                          ></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() =>
                            setIsSabreIntegrationPage(!isSabreIntegrationPage)
                          }
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Sabre</h2>
                            <span>
                              Show availability and rates within a conversation,
                              and track conversion in Sabre.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}

              {isVoucherEngine && domains.length == 1 ? (
                ''
              ) : (
                <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                  <Card
                    className="d-flex flex-row integrationcard"
                    style={{ height: '215px' }}
                  >
                    <CardBody className="mt-0">
                      <div className="connect-title">
                        <div className="integrationChannel mt-4 ml-2">
                          <img src={Amazon_logo} width="60px"></img>
                        </div>
                        <Button
                          size="xs"
                          color="primary"
                          outline
                          onClick={() => setIsAddAmazon(!isAddAmazon)}
                        >
                          Connect
                        </Button>
                      </div>
                      <Row>
                        <Colxx
                          xxs="12"
                          className="mb-5"
                          style={{ marginTop: '2rem' }}
                        >
                          <div className="text-left">
                            <h2>Amazon Connect</h2>
                            <span>Seamless handoff to Amazon Connect agents when a human touch is necessary, flagging agents when to step in.
                            </span>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Colxx>
              )}
              {/* {isVoucherEngine && domains.length == 1 ? (
              ''
            ) : (
              <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
                <Card
                  className="d-flex flex-row integrationcard"
                  style={{ height: '215px' }}
                  onClick={() => setIsAddEmbedPage(!isAddEmbedPage)}
                >
                  <div className="position-relative">
                    <h3 className="integrationChannel">
                      <img width={30} src={VirtualFront} alt="Logo" />
                    </h3>
                  </div>
                  <CardBody>
                    <Row>
                      <Colxx xxs="12" className="mb-5 mt-5">
                        <div className="text-center">
                          <div className="mb-1">
                            <h1 className="iconsminds-add" />
                          </div>
                          <h2>Embed Digital Compendium</h2>
                        </div>
                      </Colxx>
                    </Row>
                  </CardBody>
                </Card>
              </Colxx>
            )} */}
            </Fragment>
            <Colxx xxs="12" className="mb-3">
              <h1 style={{ fontSize: '1.5rem' }}>Your Installed Apps</h1>
              <Separator></Separator>
            </Colxx>

            {isLoading ? (
              <div className="text-center">
                <Spinner color="primary" className="mb-1" />
              </div>
            ) : (
              <Fragment>
                {standalonePageIntegration &&
                  (!isVoucherEngine || domains.length > 1)
                  ? standalonePageIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <StandalonePageIntregationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {salesforceIntegration
                  ? salesforceIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <SalesforceIntegrationThumb
                          integration={integration}
                          // propertyId={propertyId}
                          refreshConnection={RefreshConnection}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {/* {voucherWebsiteIntregation
          ? voucherWebsiteIntregation.map((integration, index) => {
            return (
              <Fragment key={index}>
                <VoucherWebsiteIntregationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                />
              </Fragment>
            );
          })
          : null} */}

                {/* {isCloudBeds ? (
                  <Row>
                    <Colxx xxs="12">
                      <Row>
                        <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                        <Colxx md="4" sm="4" lg="4" xxs="12">
                          <CloudsBedsIntegration
                            label={"Cloud Beds"}
                            allProperties={allProperties}
                            LoadIntegrations={LoadIntegrations}
                            visible={isCloudBeds}
                            toggle={() => {
                              setIsCloudsBeds(!isCloudBeds);
                            }}
                          />
                        </Colxx>
                        <Colxx md="4" sm="4" lg="4" xxs="12"></Colxx>
                      </Row>
                    </Colxx>
                  </Row>
                ) : null} */}
                {/* {stripeIntregation
          ? stripeIntregation.map((integration, index) => {
            return (
              <Fragment key={index}>
                <StripeIntregationThumb
                  integration={integration}
                  allProperties={allProperties}
                  LoadIntegrations={LoadIntegrations}
                  refreshConnection={RefreshConnection}
                />
              </Fragment>
            );
          })
          : null} */}
                {revinateintegrations &&
                  (!isVoucherEngine || domains.length > 1)
                  ? revinateintegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <RevinateIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {amadeusIntegration && (!isVoucherEngine || domains.length > 1)
                  ? amadeusIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <AmadeusIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {bookingEngineUrlIntegration &&
                  (!isVoucherEngine || domains.length > 1)
                  ? bookingEngineUrlIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <BookingEngineUrlIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {/* {cloudBeds ? cloudBeds.map((integration, index) => {
                  return (
                    <Fragment key={index}>
                      <CloudsBedsIntegrationThumb
                        integration={integration}
                        refreshConnection={RefreshConnection}
                        allProperties={allProperties}
                        LoadIntegrations={LoadIntegrations}
                      />
                    </Fragment>
                  );
                })
                  : null} */}
                {spaceStandAloneList
                  ? spaceStandAloneList.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <SpaceStandalonePageIntregationThumb
                          integration={integration}
                          refreshConnection={RefreshConnection}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {restApiIntegrationList
                  ? restApiIntegrationList.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <RESTApiIntegrationThumb
                          integration={integration}
                          refreshConnection={RefreshConnection}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {googleAnalytics
                  ? googleAnalytics.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <GoogleAnalyticsThumb
                          integration={integration}
                          refreshConnection={RefreshConnection}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}

                {oracleOperaIntegration &&
                  (!isVoucherEngine || domains.length > 1)
                  ? oracleOperaIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <OracleOperaIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {rmsBookingEngineData &&
                  (!isVoucherEngine || domains.length > 1)
                  ? rmsBookingEngineData.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <RMSIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {webRTCIntegrations && (!isVoucherEngine || domains.length > 1)
                  ? webRTCIntegrations.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <WebRTCIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {shrCRSIntegrationList &&
                  (!isVoucherEngine || domains.length > 1)
                  ? shrCRSIntegrationList.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <SHRCRSIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {mewsIntegrationList && (!isVoucherEngine || domains.length > 1)
                  ? mewsIntegrationList.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <MewsIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {sabreIntegrationList &&
                  (!isVoucherEngine || domains.length > 1)
                  ? sabreIntegrationList.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <SabreIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
                {amazonIntegration && (!isVoucherEngine || domains.length > 1)
                  ? amazonIntegration.map((integration, index) => {
                    return (
                      <Fragment key={index}>
                        <AmazonIntegrationThumb
                          integration={integration}
                          allProperties={allProperties}
                          LoadIntegrations={LoadIntegrations}
                        />
                      </Fragment>
                    );
                  })
                  : null}
              </Fragment>
            )}
          </Row>
        </TabPane>
      </TabContent>
      {/* </TabPane>
        <TabPane tabId="embed" className="chat-app-tab-pane">

          <FacebookIntegration fbintegrations={fbintegrations} propertyId={propertyId} LoadIntegrations={LoadIntegrations} />

        </TabPane>
      </TabContent> */}
      <StripeIntregation
        formLabel="Payment Methods in NewZeland"
        paymentmodelvisible={paymentmodelvisible}
        toggle={() => {
          setpaymentmodelvisible(!paymentmodelvisible);
        }}
        allProperties={allProperties}
        integration={stripeIntregation}
        LoadIntegrations={LoadIntegrations}
        refreshConnection={RefreshConnection}
        handleProerptyId={handleProerptyId}
        handlePayment={() => {
          checkConnection();
          setpaymentmodelvisible(!paymentmodelvisible);
          setcreateaccountModel(!createaccountModel);
        }}
      />
      <OpenAccount
        visible={createaccountModel}
        toggle={() => {
          setcreateaccountModel(!createaccountModel);
        }}
        createAccount={() => {
          handlePayment();
        }}
        deleteAccount={() => {
          stripeIntregation &&
            stripeIntregation.map((integration, index) => {
              handleDelete(integration.id);
              RefreshConnection(
                'Archieve',
                integration.channelDetails.stripeCustomerId
              );
            });
        }}
        isConnected={isConnected}
      />
      {messageVisible && (
        <ShowMessage
          formbody={'Connection established'}
          visible={messageVisible}
          isStripe={true}
          toggle={() => {
            localStorage.removeItem('ShowMessage');
            localStorage.removeItem('Message');
            setmessageVisible(!messageVisible);
          }}
        />
      )}
      {confirmMessage && (
        <ShowMessage
          formbody={'Connection established'}
          visible={confirmMessage}
          isStripe={false}
          toggle={() => {
            localStorage.removeItem('ShowConfirm');
            localStorage.removeItem('Message');
            setConfirmMeesage(!confirmMessage);
          }}
        />
      )}
      <ShowMessage
        formbody={'Connection established'}
        visible={cloudBedsVisible}
        logo={CloudBeds_Logo}
        toggle={() => {
          localStorage.removeItem('ShowCloudbedsMessage');
          setCloudsBedsVisible(!cloudBedsVisible);
        }}
      />
      <ShowMessage
        formbody={'Connection established'}
        visible={instagramVisible}
        logo={InstaLogo}
        toggle={() => {
          localStorage.removeItem('ShowInstagramMessage');
          setInstagramVisible(!instagramVisible);
        }}
      />
      <ShowMessage
        formbody={'You are already connected with Google Analytics.'}
        visible={isGoogleAnalyticsAvailable}
        logo={Analytics_Logo}
        toggle={() => {
          setIsGoogleAnalyticsAvailable(!isGoogleAnalyticsAvailable);
        }}
      />
      <ShowWarningMessage
        visible={warningMsgVisible}
        toggle={toggleWarning}
      ></ShowWarningMessage>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  let { propertyId, email, isVoucherEngine, domains, locale, integrationTab } =
    settings;
  return {
    propertyId,
    email,
    isVoucherEngine,
    domains,
    locale,
    integrationTab,
  };
};

export default injectIntl(
  connect(mapStateToProps, { changeTabs })(Integrations)
);
